module.exports = __webpack_public_path__ + "media/images/slider-arrow-8cb5ce6d40789b807a3bc145ad4bfe1c.svg";